import * as Yup from "yup";

export const adminValidationSchema = Yup.object().shape({
   name: Yup.string()
      .min(3, "Minimum 3 symbols")
      .max(50, "Maximum 50 symbols")
      .required("Name is required"),

   phoneNumber: Yup.string()
      .min(3, "Minimum 3 symbols")
      .max(50, "Maximum 50 symbols")
      .required("Phone number is required")
});

export const ngoValidationSchema = Yup.object().shape({
   organizationName: Yup.string()
      .min(3, "Minimum 3 symbols")
      .max(50, "Maximum 50 symbols")
      .required("Name is required"),
   organizationEmail: Yup.string()
      .email("Invalid organization email")
      .required("Organization's email is required"),
   baseCountryId: Yup.string()
      .nullable()
      .required("Base country is required"),
   cityId: Yup.string().nullable(),
   // .required("City is required"),
   address: Yup.string().required("Organization address is required")
});

// wait till fixed from backend
export const ngoMemberValidationSchema = Yup.object().shape({
   name: Yup.string()
      .min(3, "Minimum 3 symbols")
      .max(50, "Maximum 50 symbols")
      .required("Name is required"),
   // birthday: Yup.string().required("Birthday is required"),
   gender: Yup.string().required("Gender is required")
});

export const donorValidationSchema = Yup.object().shape({
   name: Yup.string()
      .min(3, "Minimum 3 symbols")
      .max(50, "Maximum 50 symbols")
      .required("Name is required"),
   baseCountryId: Yup.string()
      .nullable()
      .required("Base country is required")
});

export const humanitarianValidationSchema = Yup.object().shape({
   name: Yup.string()
      .min(3, "Minimum 3 symbols")
      .max(50, "Maximum 50 symbols")
      .required("Name is required"),
   // baseCountryId: Yup.string()
   //    .nullable()
   //    .required("Base country is required"),
   // personalStatement: Yup.string().required("Personal statement is required"),
   residenceCountryId: Yup.string().required("Name is required"),
   operatingCountriesIds: Yup.string()
      .min(1, "At least 1 country is required")
      .required("Operating countries is required"),
   // HigestDegree: Yup.object()
   //    .shape({
   //       value: Yup.string().required("Degree value is required"), // Validate the `value` property
   //       label: Yup.string().required("Degree label is required") // Validate the `label` property
   //    })
   //    .nullable()
   //    .required("Highest degree is required"),
   Expertises: Yup.array().of(
      Yup.object().shape({
         areaName: Yup.string().required("Area is required"),
         areaExperienceYears: Yup.number()
            .required("Years of experience is required")
            .typeError("Years of experience must be a number")
      })
   ),

   Languages: Yup.array().of(
      Yup.object({
         languageId: Yup.string().required("Language is required"),
         level: Yup.number()
            .required("Level is required")
            .typeError("Level must be a number")
      })
   )
});
